import React, { Component } from 'react';
import { map } from 'lodash';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { DropdownButton, MenuItem } from 'react-bootstrap';
import { imageBasePath } from '../../constants/staticData';
import PageLoader from '../common/PageLoader';

class CustomBarChart extends Component {
  constructor() {
    super();
    this.state = {
      barChartChevron: false,
      barChartWidth: 410,
      barChartHeight: 50,
      showSidebar: false
    };
  }
  componentWillMount() {
    window.addEventListener('resize', this.updateWindowDimensions.bind(this));
  }
  componentDidMount() {
    this.updateWindowDimensions()
    window.addEventListener('resize', this.updateWindowDimensions.bind(this));
  }
  updateWindowDimensions() {
    // if (window.innerWidth < 1366 && window.innerWidth > 991) {
    //   this.setState({ barChartWidth: 85 })
    // } else if (window.innerWidth < 450) {
    //   this.setState({ barChartWidth: 60 })
    // } else if (window.innerWidth < 570) {
    //   this.setState({ barChartWidth: 80 })
    //}
  }
  onMouseOver() {
  }

  render() {
    return (
      <div className="col-md-8 mpad0 padLeft0">
        <div className="overview-card">
          <a><h5> JOBS </h5></a>
          {/* <DropdownButton bsSize="small" noCaret id="dropdown-size-small" onToggle={(e) => this.setState({ barChartChevron: e })}
            open={this.state.barChartChevron}
            title={
              <span>
                <span>{this.props.title}</span>
                <i className={this.state.barChartChevron ? "mdi mdi-chevron-up" : "mdi mdi-chevron-down"} />
              </span>
            }>
            <MenuItem eventKey="week" onClick={this.props.weekView}>This Week</MenuItem>
            <MenuItem eventKey="month" onClick={this.props.monthView}>This Month</MenuItem>
          </DropdownButton> */}
          {!this.props.isLoading ? this.props.Chartdata && this.props.Chartdata.length ? <div className="n-graph-holder">
            <span className="yAxis-label">
              NO. OF JOBS
              </span>
            <ResponsiveContainer>
              <BarChart width={this.state.barChartWidth} height={this.state.barChartHeight} data={this.props.Chartdata}
                margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
                <XAxis dataKey="name" />
                <YAxis />
                <CartesianGrid strokeDasharray="3 3" />
                <Tooltip />
                {/* <Legend /> */}
                <Bar dataKey="win" fill="#06c3da" barSize={8}/>
                <Bar dataKey="loss" fill="#E16D5B" barSize={8}/>
              </BarChart>
            </ResponsiveContainer>
            <span className="xAxis-label">Days </span>
          </div>
            :
            <div style={{ textAlign: 'center' }} className="empty-data-text">
              <img src={`${imageBasePath}/jobs.png`} alt="Top Location not available" />
              <h4>You can see this once you start receiving Jobs </h4>
            </div>
            : <PageLoader />}

          {/* <div className="charts-holder bar-chart" id="charts-holder">
            <span className="yAxis-label">
              NO. OF JOBS
            </span>

            <div className="inline-disp bar-chart-box">
              {map(this.props.Chartdata, (week, index) => {
                return (
                  <div className="chats">
                    <BarChart width={this.state.barChartWidth} height={this.state.barChartHeight}
                      data={week.data} >
                      <Bar dataKey="pv" fill="#06c3da" nameKey="name" />
                      <Bar dataKey='uv' fill='#E16D5B' nameKey="name" />
                      <XAxis dataKey="name" />
                      <Tooltip />
                    </BarChart>

                    {this.props.title == "This Month" ?
                      <span className="xAxis-label">week {index + 1}</span> :
                      <span className="xAxis-label">Days </span>
                    }
                  </div>
                );
              })}
            </div>

          </div> */}
          <ul className="graph-tooltip graph-tooltip-mobile">
            <li><span>Won</span></li>
            <li><span>Lost</span></li>
          </ul>
        </div>
      </div>
    );
  }
}

export default CustomBarChart;



// WEBPACK FOOTER //
// ./src/components/Overview/CustomBarChart.jsx